import React from 'react';

const VillageIcon = (props) => {
  return (
    <img
      alt="Skansen"
      src="/static/images/icons/tourist_attractions/village.svg"
      {...props}
    />
  );
};

export default VillageIcon;
